"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoCallout = exports.ValidationCallout = exports.CalloutLinkButton = exports.CalloutButton = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _tinycolor = _interopRequireDefault(require("tinycolor2"));

var _shared = require("@widget-editor/shared");

var _style = require("../callout/style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Container = _styledComponents["default"].div.withConfig({
  displayName: "style__Container",
  componentId: "sc-162shcl-0"
})(["label{margin-top:20px;}"]);

exports.Container = Container;
var CalloutButton = (0, _styledComponents["default"])(_shared.Button).withConfig({
  displayName: "style__CalloutButton",
  componentId: "sc-162shcl-1"
})(["margin-top:10px;"]);
exports.CalloutButton = CalloutButton;
var CalloutLinkButton = (0, _styledComponents["default"])(_shared.Button).withConfig({
  displayName: "style__CalloutLinkButton",
  componentId: "sc-162shcl-2"
})(["margin-top:10px;padding:0;border:none;font-size:inherit;color:", ";&:hover:not([disabled]){border:none;}"], function (props) {
  return props.themeColor;
});
exports.CalloutLinkButton = CalloutLinkButton;
var ValidationCallout = (0, _styledComponents["default"])(_style.StyledCallout).withConfig({
  displayName: "style__ValidationCallout",
  componentId: "sc-162shcl-3"
})(["margin-top:20px;border:1px solid #ff4141;border-radius:4px;background-color:", ";ul{padding-left:1em;li{margin-top:5px;}}"], function (props) {
  return (0, _tinycolor["default"])('#ff4141').setAlpha(0.05).toRgbString();
});
exports.ValidationCallout = ValidationCallout;
var InfoCallout = (0, _styledComponents["default"])(_style.StyledCallout).withConfig({
  displayName: "style__InfoCallout",
  componentId: "sc-162shcl-4"
})(["margin-top:20px;padding:0;border:none;background:none;a{text-decoration:underline;color:inherit;}"]);
exports.InfoCallout = InfoCallout;